'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadMaCreatorInfoWindowImage = exports.deleteMarkerType = exports.createMarkerType = exports.fetchMapCreatorMarkerTypes = undefined;

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchMapCreatorMarkerTypes = exports.fetchMapCreatorMarkerTypes = function fetchMapCreatorMarkerTypes() {
  return (0, _callApi2.default)('GET', '/map-creator/marker-types');
};
var createMarkerType = exports.createMarkerType = function createMarkerType(file_data) {
  return (0, _callApi2.default)('POST', '/map-creator/create-new-marker-type', file_data);
};
var deleteMarkerType = exports.deleteMarkerType = function deleteMarkerType(marker_id) {
  return (0, _callApi2.default)('DELETE', '/map-creator/delete-marker-type/' + marker_id);
};
var uploadMaCreatorInfoWindowImage = exports.uploadMaCreatorInfoWindowImage = function uploadMaCreatorInfoWindowImage(map_id, feature_id, file_data) {
  return (0, _callApi2.default)('POST', '/map-creator/upload-info-window-image/' + map_id + '/' + feature_id, file_data);
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/map-creator.js
// module id = 734
// module chunks = 0